import React from 'react';
import { compact } from 'lodash/fp';
import Item from './Item';

const ActionList = ({ items }) => (
  <ul className="ActionList" role="listbox">
    {compact(items).map((item, i) => (
      <Item
        key={item.url || i}
        disabled={item.disabled}
        buttonClassName={item.buttonClassName}
        iconClassName={item.iconClassName}
        onClick={item.onClick}
        url={item.url}
        icon={item.icon}
        FeatherIcon={item.FeatherIcon}
        content={item.content}
        secondaryAction={item.secondaryAction}
        secondaryText={item.secondaryText}
        openInNewTab={item.openInNewTab}
      />
    ))}
  </ul>
);

export default ActionList;
